import type { HeaderAction, HeaderActionStyle, HeaderContent, WebsiteLink } from './types'

const actionStyles = new Set<HeaderActionStyle>(['primary', 'secondary', 'tertiary'])

export function resolveHeaderActions(content: HeaderContent): HeaderAction[] {
  const legacyAction = (content as HeaderContent & { callToAction?: WebsiteLink }).callToAction
  const candidates = content.actions?.length
    ? content.actions
    : legacyAction
      ? [{
          style: 'primary' as const,
          link: legacyAction,
          showOnDesktop: true,
          showOnSmall: true,
        }]
      : []
  const seen = new Set<HeaderActionStyle>()

  return candidates
    .filter((action) => {
      if (!actionStyles.has(action.style) || seen.has(action.style)) return false
      seen.add(action.style)

      return true
    })
    .slice(0, 3)
    .map((action) => ({
      ...action,
      showOnDesktop: action.showOnDesktop ?? true,
      showOnSmall: action.showOnSmall ?? false,
    }))
}
